import React from "react";
import { Box } from "@mui/material";
import MUITypography from "../../Components/MUITypography";
import { VM_Colors } from "../../Styles/VMStyles";

export const FeatureCard = ({
  index,
  title,
  description,
  icon,
}) => {
  const isLeft = index % 2 === 0;

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        mb: { xs: 3, md: 5 },
        position: "relative",
        flexDirection: {
          xs: "column",
          md: isLeft ? "row" : "row-reverse",
        },
      }}
    >
      {/* Text Content */}
      <Box
        sx={{
          width: { xs: "100%", md: "45%" },
          textAlign: { xs: "center", md: isLeft ? "right" : "left" },
          pr: { md: isLeft ? 3 : 0 },
          pl: { md: !isLeft ? 3 : 0 },
        }}
      >
        <MUITypography
          sx={{
            fontSize: 22,
            fontWeight: 700,
            color: VM_Colors.primary || "#0f172a",
            mb: 1,
          }}
        >
          {title}
        </MUITypography>

        <MUITypography
          sx={{
            fontSize: 15,
            color: VM_Colors.black || "#64748b",
            lineHeight: 1.7,
          }}
        >
          {description}
        </MUITypography>
      </Box>

      {/* Center Number */}
      <Box
        sx={{
          position: "absolute",
          left: "50%",
          transform: "translateX(-50%)",
          width: 60,
          height: 60,
          borderRadius: "50%",
          backgroundColor: VM_Colors.white1,
          // background: "linear-gradient(135deg, #f59e0b, #22d3ee)",
          display: { xs: "none", md: "flex" },
          alignItems: "center",
          justifyContent: "center",
          fontSize: 40,
          fontWeight: 800,
          color: "#959595",
          zIndex: 2,
          boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
        }}
      >
        {index + 1}
      </Box>

      {/* Illustration */}
      <Box
        sx={{
          width: { xs: "100%", md: "45%" },
          display: "flex",
          justifyContent: "center",
          mt: { xs: 3, md: 0 },
        }}
      >
        <Box
          component="img"
          src={icon}
          alt={title}
          loading="lazy"
          sx={{
            width: { xs: 200, md: 260 },
            height: "auto",
          }}
        />
      </Box>
    </Box>
  );
};

export default FeatureCard;
